/*
    sidebar component should be a component usable for all main views
*/
import React, { useState } from "react";
import { rbac } from "../../index";
import t from "../../../../helpers/t";
import NewUserGroupButton from "./NewUserGroupButton";
import { $, DropdownButton, Dropdown } from "../../../../../../vendor";
import { getApiHost } from "../../../../../Sync";
import { Biscuit } from "../../../../../utils";
import * as FileSaver from "../../../../../../vendor/FileSaver";

const UserGroupSidebar = (props) => {
  const [globalFilter, setGlobalFilter] = useState({}); // set empty object, there are no filters set by default

  const [statusFilter, setStatusFilter] = useState({ value: "all" }); // 'all', 'active', 'inactive'
  const [roleFilter, setRoleFilter] = useState({ value: "all" }); // 'all', 'admin', 'manager', 'booking-manager', 'mediator', optional: 'manager-location', 'garage-staff', 'guide'

  const onToggleLeftBar = (ev) => {
    $("#inb-c-sidebar").toggleClass("open");
    $("html,body").scrollTop(0);
  };

  const onStatusFilterChange = (val) => {
    setStatusFilter({ value: val }); // set status filter
    var clone = {};
    Object.assign(clone, globalFilter); // get current filter settings (all filter)

    if (val == "active") {
      // add status filter to global filter
      clone.active = "1";
    } else if (val == "inactive") {
      clone.active = "0";
    } else {
      delete clone["active"];
    }

    setGlobalFilter(clone);
    props.setSelectedFilter(clone); // cloned object must be used because global filter is not yet updated
  };

  const onRoleFilterChange = (val) => {
    setRoleFilter({ value: val }); // set status filter
    var clone = {};
    Object.assign(clone, globalFilter); // get current filter settings (all filter)

    if (val == "all") {
      // remove role filter from global filter
      delete clone["role"];
    } else {
      clone.role = val;
    }

    setGlobalFilter(clone);
    props.setSelectedFilter(clone); // cloned object must be used because global filter is not yet updated
  };

  const onExportXLS = () => {
    const that = this;
    let params = "",
      count = 0;

    for (var key in globalFilter) {
      if (count > 0) params += "&" + key + "=" + globalFilter[key];
      else params += "?" + key + "=" + globalFilter[key];
      count++;
    }

    const xmlHttp = new XMLHttpRequest();

    xmlHttp.open("GET", getApiHost() + "/users/export" + params, true);

    //  xmlHttp.setRequestHeader('Accept', 'application/json')
    xmlHttp.setRequestHeader("Authorization", "Bearer " + Biscuit.get("token"));
    xmlHttp.setRequestHeader("Content-Language", Biscuit.get("user.lang").replace("-", "_"));
    xmlHttp.responseType = "blob";

    xmlHttp.onload = function () {
      const blob = new Blob([xmlHttp.response], { type: "application/xls" });
      FileSaver.saveAs(blob, t("users") + " " + get_today() + ".xlsx");
    };
    xmlHttp.send(null);
  };

  const get_today = () => {
    let today = new Date();

    let day = today.getDate(); // Tag

    // Monatsangabe startet bei 0!
    let month = today.getMonth() + 1; // Monat

    let year = today.getFullYear(); // Jahr
    if (day < 10) {
      day = "0" + day;
    }
    if (month < 10) {
      month = "0" + month;
    }
    today = day + "." + month + "." + year;

    return today;
  };
  const onToggleDropdown = (nextShow, meta) => {
    if (nextShow) {
      $(".sticky-top-sortbar").addClass("hide");
    } else {
      $(".sticky-top-sortbar").removeClass("hide");
    }
  };
  return (
    <aside id="inb-c-sidebar" className="resources-sidebar" style={{ float: "left" }}>
      <header className="inb-c-left-bar__title  sticky-top">
        <h1 className="inb-page-title">{t("usergroups", null, "capital")}</h1>
        <aside className="inb-c-item__actions">
          <DropdownButton
            id="dropdown-basic-button"
            title="..."
            variant="secondary"
            drop="up-centered"
            menuAlign="left"
            align="end"
            bsPrefix="button round inb-toggle-contingent-dd hover"
            onToggle={onToggleDropdown}
          >
            {" "}
            <ul className="inb-dropdown__list">
              {false && (
                <li className="inb-order__edit">
                  <a className="help-link" href="/users/help">
                    <i className="ico-inb inb-fi-help"></i>
                    {t("help", null, "capital")}
                  </a>
                </li>
              )}
              {false && <li className="spacer"></li>}
              <li>
                <Dropdown.Item href="#" onClick={() => onExportXLS()}>
                  <i className="ico-inb inb-fi-excel"></i>
                  {t("export_xls", null, "capital")}
                </Dropdown.Item>
              </li>
            </ul>
          </DropdownButton>
        </aside>
      </header>
      <div className="sticky-top-filter"></div>
      <footer
        className="inb-c-left-bar__footer small-only-float-container"
        data-inb-action-link="write"
      >
        <a
          href="#"
          id="toggle-left-bar"
          className="button secondary show-for-small-only"
          onClick={(e) => onToggleLeftBar(e)}
        >
          <i className="fi fi-filter"></i>
          <span className="show-for-sr">{t("open_filter_menu")}</span>
        </a>
        {rbac.hasPermission("write") && (
          <NewUserGroupButton url={"/usersExtension/userGroups/add"} />
        )}
      </footer>
    </aside>
  );
};

export default UserGroupSidebar;
